module.exports = __webpack_public_path__ + "static/media/ne.9a558973.svg";